
// import React, { useState, useEffect, useContext, useRef } from "react";
// import { plantCurveApi } from "../../../../../../../api/Api";
// import EnergyChartPower from "../../../../../../../components/charts/energy_reporting/EnergyChartPower";
// import { AppThemeContext } from "../../../../../../../context/AppThemeContext";
// import { useTheme } from "@emotion/react";
// import AppModal from "../../../../../../../components/AppModal";
// import InvverterFullSize from "../../../../../../../components/inverter/InvverterFullSize";
// import DownloadJpegButton from "../../../../../../../components/downloadJpegButton/DownloadJpegButton";

// // Utility function to format date as 'YYYY-MM-DD HH:mm'
// const formatDateTime = (date) => {
//     const pad = (num) => String(num).padStart(2, "0");
//     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
// };

// export default function PlantEnergyData() {
//     const chartRef = useRef();
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const { palette } = useTheme();
//     const [OpenMix, setOpenMix] = useState(false);
//     const handleOpenMix = () => setOpenMix(true);
//     const handleCloseMix = () => setOpenMix(false);

//     const now = new Date(); // Current date and time

//     // Default start and end dates
//     const initialStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 5, 0); // 5:00 AM
//     const initialEndDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0); // 8:00 PM

//     const [startDate, setStartDate] = useState(formatDateTime(initialStartDate));
//     const [endDate, setEndDate] = useState(formatDateTime(initialEndDate));
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);

//     const [chartLabels, setChartLabels] = useState([]);
//     const [chartData, setChartData] = useState([]);
//     const [gradientFill, setGradientFill] = useState(null);

//     const credentials = {
//         LOGIN_ID: localStorage.getItem("LoginID") || "",
//         PASS_KEY: localStorage.getItem("KEY") || "xyz",
//         LOC_CODE: localStorage.getItem("LCODE") || "",
//         DT1: startDate,
//         DT2: endDate,
//         WEB_KEY: "WEBXYZ321",
//     };

//     // Fetch log data from the API
//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);

//         try {
//             const res = await plantCurveApi(credentials);

//             if (res?.data && Array.isArray(res.data)) {
//                 const labels = res.data.map((item) => item.datet);

//                 const datasets = [
//                     {
//                         label: "Plant Total (kW)",
//                         data: res.data.map((item) => parseFloat(item.TOT_INV_KW) || 0),
//                         borderColor: "red",
//                         backgroundColor: gradientFill,
//                         tension: 0.3,
//                         fill: true,
//                         borderWidth: 2,
//                         pointRadius: 0.9,
//                         pointHoverRadius: 1,
//                     },
//                     // Add other datasets here as needed
//                 ];

//                 setChartLabels(labels);
//                 setChartData(datasets);
//             } else {
//                 // console.warn("Empty or Invalid API Response Data");
//                 setChartLabels([]);
//                 setChartData([]);
//             }
//         } catch (err) {
//             // console.error("API Error:", err);
//             setError("Failed to fetch data. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const createGradientShade = () => {
//         const canvas = document.createElement("canvas");
//         const ctx = canvas.getContext("2d");
//         const gradient = ctx.createLinearGradient(0, 0, 0, 400);
//         gradient.addColorStop(0, palette.primary.main);
//         gradient.addColorStop(1, "rgba(255, 255, 255, 0)");
//         return gradient;
//     };

//     useEffect(() => {
//         setGradientFill(createGradientShade());
//     }, [palette.primary.main]);

//     // Fetch data on component mount and set up 30-second interval
//     useEffect(() => {
//         fetchLogData(); // Fetch data initially

//         // Set up interval for 30-second refresh
//         const interval = setInterval(() => {
//             fetchLogData();
//         }, 300000); // 30 seconds

//         // Clean up interval on component unmount
//         return () => clearInterval(interval);
//     }, [startDate, endDate, gradientFill]);

//     const handleStartDateChange = (value) => {
//         const formattedDate = formatDateTime(new Date(value));
//         setStartDate(formattedDate);
//     };

//     const handleEndDateChange = (value) => {
//         const formattedDate = formatDateTime(new Date(value));
//         setEndDate(formattedDate);
//     };

//     return (

//         <>
//             <div className="row">

//                 <div className="col-md-12">

//                     <div style={{
//                         marginBottom: "5px",
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         gap: "16px",
//                     }}>
//                         {/* Left-side title */}
//                         <div style={{ marginLeft: "7px", fontSize: "10px" }}>
//                             Plant [kW]
//                         </div>

//                         {/* Right-side date pickers */}
//                         <div style={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "10px"
//                         }}>
//                             <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                                 <span>From:</span>
//                                 <input
//                                     type="datetime-local"
//                                     value={startDate.replace(" ", "T")}
//                                     onChange={(e) => handleStartDateChange(e.target.value)}
//                                     style={{
//                                         padding: "2px 8px",
//                                         borderRadius: "14px",
//                                         border: "1px solid #ccc",
//                                     }}
//                                 />
//                             </label>
//                             <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                                 <span>To:</span>
//                                 <input
//                                     type="datetime-local"
//                                     value={endDate.replace(" ", "T")}
//                                     onChange={(e) => handleEndDateChange(e.target.value)}
//                                     style={{
//                                         padding: "2px 8px",
//                                         borderRadius: "14px",
//                                         border: "1px solid #ccc",
//                                     }}
//                                 />
//                             </label>

//                             <DownloadJpegButton targetRef={chartRef} fileName={`Plant [kW].jpeg`} />
//                         </div>
//                     </div>

                    
//                     <div ref={chartRef} >
//                         <EnergyChartPower labels={chartLabels} data={chartData} title={``} />
//                     </div>

//                 </div>

//             </div>

//         </>


//     );
// }


import React, { useState, useEffect, useContext, useRef } from "react";
import { plantCurveApi } from "../../../../../../../api/Api";
import EnergyChartPower from "../../../../../../../components/charts/energy_reporting/EnergyChartPower";
import { AppThemeContext } from "../../../../../../../context/AppThemeContext";
import { useTheme } from "@emotion/react";
import DownloadJpegButton from "../../../../../../../components/downloadJpegButton/DownloadJpegButton";
import { IoIosRefresh } from "react-icons/io";

// Utility function
const formatDateTime = (date) => {
  const pad = (num) => String(num).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export default function PlantEnergyData() {
  const chartRef = useRef();
  const { PrimaryColor } = useContext(AppThemeContext);
  const { palette } = useTheme();

  const now = new Date();

  // Default start & end
  const initialStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 5, 0);
  const initialEndDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0);

  const [startDate, setStartDate] = useState(formatDateTime(initialStartDate));
  const [endDate, setEndDate] = useState(formatDateTime(initialEndDate));
  const [loading, setLoading] = useState(false);
  const [chartLabels, setChartLabels] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [gradientFill, setGradientFill] = useState(null);

  // ✅ Fetch API
  const fetchLogData = async () => {
    console.log("🔄 API Refresh Hit"); // DEBUG

    setLoading(true);

    const credentials = {
      LOGIN_ID: localStorage.getItem("LoginID") || "",
      PASS_KEY: localStorage.getItem("KEY") || "xyz",
      LOC_CODE: localStorage.getItem("LCODE") || "",
      DT1: startDate,
      DT2: endDate,
      WEB_KEY: "WEBXYZ321",
    };

    try {
      const res = await plantCurveApi(credentials);

      if (res?.data && Array.isArray(res.data)) {
        const labels = res.data.map((item) => item.datet);

        const datasets = [
          {
            label: "Plant Total (kW)",
            data: res.data.map((item) => parseFloat(item.TOT_INV_KW) || 0),
            borderColor: "red",
            backgroundColor: gradientFill,
            tension: 0.3,
            fill: true,
            borderWidth: 2,
            pointRadius: 1,
          },
        ];

        setChartLabels(labels);
        setChartData(datasets);
      } else {
        setChartLabels([]);
        setChartData([]);
      }
    } catch (err) {
      console.log("❌ API Error", err);
    } finally {
      setLoading(false);
    }
  };

  // Gradient
  const createGradientShade = () => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, palette.primary.main);
    gradient.addColorStop(1, "rgba(255,255,255,0)");
    return gradient;
  };

  useEffect(() => {
    setGradientFill(createGradientShade());
  }, [palette.primary.main]);

  // ✅ Initial + Auto refresh (5 min)
  useEffect(() => {
    fetchLogData();

    const interval = setInterval(() => {
      fetchLogData();
    }, 300000);

    return () => clearInterval(interval);
  }, [gradientFill]);

  // Handlers
  const handleStartDateChange = (value) => {
    setStartDate(formatDateTime(new Date(value)));
  };

  const handleEndDateChange = (value) => {
    setEndDate(formatDateTime(new Date(value)));
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12">

          {/* HEADER */}
          <div
            style={{
              marginBottom: "5px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "16px",
            }}
          >
            {/* Title */}
            <div style={{ marginLeft: "7px", fontSize: "12px" }}>
              Plant [kW]
            </div>

            {/* Controls */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              
              {/* From */}
              <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <span>From:</span>
                <input
                  type="datetime-local"
                  value={startDate.replace(" ", "T")}
                  onChange={(e) => handleStartDateChange(e.target.value)}
                  style={{
                    padding: "2px 8px",
                    borderRadius: "14px",
                    border: "1px solid #ccc",
                  }}
                />
              </label>

              {/* To */}
              <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <span>To:</span>
                <input
                  type="datetime-local"
                  value={endDate.replace(" ", "T")}
                  onChange={(e) => handleEndDateChange(e.target.value)}
                  style={{
                    padding: "2px 8px",
                    borderRadius: "14px",
                    border: "1px solid #ccc",
                  }}
                />
              </label>

              {/* ✅ Manual Refresh */}
              <IoIosRefresh
                onClick={() => {
                  console.log("Manual Refresh Clicked");
                  fetchLogData();
                }}
                style={{
                  cursor: "pointer",
                  fontSize: "20px",
                  color: PrimaryColor,
                  animation: loading ? "spin 1s linear infinite" : "none",
                }}
                title="Refresh Data"
              />

              {/* Download */}
              <DownloadJpegButton
                targetRef={chartRef}
                fileName="Plant_kW.jpeg"
              />
            </div>
          </div>

          {/* ✅ Loading Indicator */}
          {loading && (
            <div style={{ textAlign: "center", fontSize: "12px", color: "gray" }}>
              🔄 Refreshing data...
            </div>
          )}

          {/* Chart */}
          <div ref={chartRef}>
            <EnergyChartPower
              key={JSON.stringify(chartLabels)}
              labels={chartLabels}
              data={chartData}
              title=""
            />
          </div>

        </div>
      </div>

      
      <style>
        {`
          @keyframes spin {
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      
    </>
  );
}
